import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import React from 'react'

import Select from '~/components/Form/Select'
import ProductSliderSelect from '~/components/UI/ProductHeader/ProductSliderSelect'

import { ProductVariations } from '~/data/product-page-data/serialize-product-header'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type ProductVariationsSelectProps = ProductVariations & {
  className?: string
  mainCss?: Record<string, string>
}

function ProductVariationsSelect({
  mainCss,
  items,
  active,
}: ProductVariationsSelectProps) {
  const router = useRouter()

  const selectItems = items?.map((item, index) => {
    return {
      label: item?.label,
      value: item?.link?.href.toString(),
      selected: item?.uuid === active?.uuid,
      disabled: item?.uuid === active?.uuid,
    }
  })

  const onChangeItem = (href) => {
    router.push(href)
  }

  return (
    <>
      <Select
        options={selectItems}
        className={cx(mainCss.select, mainCss.hideOnSmallScreen)}
        onChange={(e) => {
          onChangeItem(e.target.value)
        }}
      />

      <ProductSliderSelect
        theme={'small'}
        className={cx(mainCss.select, mainCss.hideOnLargeScreen)}
        items={selectItems}
        onChange={(value) => {
          onChangeItem(value)
        }}
      />
    </>
  )
}

ProductVariationsSelect.defaultProps = {}

export default ProductVariationsSelect
